// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__7UY1Z","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3BjIe","obliqueLine":"membershipbadge_obliqueLine__qB9Kx"};